document.addEventListener("DOMContentLoaded", function () {
  // Add to Cart button selector
  var addToCartButtons = document.querySelectorAll(
    ".tvg_recharge_product_add_to_cart_form_nGmuOW_ProductForm-submitButton"
  );
  const atcBtns = document.querySelectorAll(
    ".tvg_recharge_product_add_to_cart_form_widget_foYHaW_ProductForm-submitButton"
  );

  const shopAllAtcBtns = document.querySelectorAll('.js-shop-all-atc');

  const reploATCBtn = document.querySelectorAll(
    '[data-replo-add-product-variant-to-cart]'
  )

  const conversationTracking = (variantId) => {
    if (
      variantId === "39353652117609" ||
      variantId === "39353652150377" ||
      variantId === "39353652183145"
    ) {
      // Trigger Convert Experiments conversion tracking for Mushroom Coffee 30 Serving ATC
      window._conv_q = window._conv_q || [];
      _conv_q.push(["triggerConversion", "100462016"]);
    } else if (variantId === "32925928751209") {
      // Check if the variant belongs to Starter Kit product
      // Trigger Convert Experiments conversion tracking for Starter Kit ATC
      window._conv_q = window._conv_q || [];
      _conv_q.push(["triggerConversion", "100462017"]);
    }
  };

  // const productMapping = {
  //   41692518776937: [
  //     "3630836383849",
  //     "6738597380201",
  //     "6731774525545",
  //     "7029957787753",
  //     "6994585387113",
  //     "7129178210409",
  //     "7129178767465",
  //     "6909454876777",
  //     "7143607730281",
  //     "7129557500009",
  //     "7129560252521",
  //     "7129559007337",
  //     "6869344977001",
  //     "6731774525545",
  //     "6866719375465",
  //     "6868886650985",
  //     "7143607730281",
  //     "6994780782697",
  //     "6994585387113",
  //     "7125297463401",
  //     "7125300838505",
  //     "7084493635689",
  //     "7092029227113",
  //     "7091854770281",
  //     "7092036632681",
  //     "7091881967721",
  //     "7124275953769",
  //     "7125300576361",
  //     "7125297463401",
  //     "7125300838505",
  //     "7125298479209",
  //     "7125297463401",
  //     "7091854770281",
  //     "7091881967721",
  //     "7131257569385",
  //     "128799576169",
  //     "7029957787753",
  //     "7143619035241",
  //     "7129178210409",
  //     "6980312793193",
  //     "4828355919977",
  //     "7128799576169",
  //     "7124276707433",
  //     "7125300641897",
  //     "7091881967721",
  //     "7091881967721",
  //     "7126186754153",
  //     "7395914743913",
  //     "7395919560809",
  //     "7395922215017",
  //     "7395924967529",
  //     "7395923001449",
  //     "7395922608233",
  //     "7395925360745",
  //     "7395923591273",
  //     "7416223891561",
  //     "7416224514153",
  //   ],
  //   41744661446761: [
  //     "7125298479209",
  //     "7125297463401",
  //     "7091854770281",
  //     "7091881967721",
  //     "7131257569385",
  //     "128799576169",
  //     "7029957787753",
  //     "7143619035241",
  //     "7129178210409",
  //     "6980312793193",
  //     "4828355919977",
  //     "7128799576169",
  //     "395924967529",
  //     "7395922215017",
  //     "7395924967529",
  //     "7395923001449",
  //     "7395922608233",
  //     "7395925360745",
  //     "7395923591273",
  //     "7416223891561",
  //     "7416224514153",
  //   ],
  //   40959005622377: [
  //     "7084493635689",
  //     "7092029227113",
  //     "7091854770281",
  //     "7092036632681",
  //     "7091881967721",
  //   ],
  //   41744663904361: [
  //     "3630836383849",
  //     "4828355919977",
  //     "7131257569385",
  //     "7128799576169",
  //     "7129178767465",
  //     "7129178210409",
  //     "7084493635689",
  //     "7091854770281",
  //     "7091881967721",
  //     "6994585387113",
  //     "7029957787753",
  //     "7143619035241",
  //     "7124275953769",
  //     "7124276707433",
  //     "7125297463401",
  //     "7125298479209",
  //     "7395914743913",
  //     "7395922215017",
  //     "7395924967529",
  //     "7395923001449",
  //     "7416223891561",
  //   ],
  //   41631372378217: ["7125298479209", "7126186754153"],
  //   41759977111657: [
  //     "7395914743913",
  //     "7395919560809",
  //     "7395922215017",
  //     "7395924967529",
  //     "7395923001449",
  //     "7395922608233",
  //     "7395925360745",
  //     "7395923591273",
  //     "3630836383849",
  //     "6738597380201",
  //     "6731774525545",
  //     "7029957787753",
  //     "6994585387113",
  //     "7129178210409",
  //     "7129178767465",
  //     "6909454876777",
  //     "7143607730281",
  //     "7129557500009",
  //     "7129560252521",
  //     "7129559007337",
  //     "6869344977001",
  //     "6866719375465",
  //     "6868886650985",
  //     "6994780782697",
  //     "7125297463401",
  //     "7125300838505",
  //     "4828355919977",
  //     "7131257569385",
  //     "7128799576169",
  //     "7084493635689",
  //     "7091854770281",
  //     "7143619035241",
  //     "40205337264233",
  //     "41803176018025",
  //     "41803184242793",
  //     "41803199053929",
  //     "41803193909353",
  //     "41803194957929",
  //     "41803196792937",
  //     "41803200561257",
  //     "7416223891561",
  //     "7416224514153",
  //   ],
  //   40441538936937: [
  //     "40964963795049",
  //     "7126186754153",
  //     "7125300838505",
  //     "7125297463401",
  //   ],
  //   41849056985193: [
  //     "7395914743913",
  //     "7395919560809",
  //     "7395922215017",
  //     "7395924967529",
  //     "7395923001449",
  //     "7395922608233",
  //     "7395925360745",
  //     "7395923591273",
  //     "7416223891561",
  //     "7416224514153",
  //   ],
  // };
   if (reploATCBtn) {
    reploATCBtn.forEach((button) => {
      button.addEventListener("click", async function (event) {
        event.stopPropagation();
        event.preventDefault();

        var originalButtonText = button.textContent;
        button.style.display = 'flex'
        button.style.justifyContent = 'center'
        button.innerHTML = `<div class="loading__spinner__add-to-cart"></div>`;
        const productFormContainer = button.closest("[data-replo-product-container]");
        const productForm = productFormContainer.querySelector("form");

        if (productForm && window.freeGiftMapping) {
          const variantInput = productForm.querySelector('input[name="id"]');
          const sellingPlanInput = productForm.querySelector(
            'input[name="selling_plan"]'
          );
          if (variantInput) {
            const variantId = variantInput.value;
            conversationTracking(variantId)
            let body = {
              id: variantId,
              quantity: 1,
            };
            if (sellingPlanInput) {
              body = { ...body, selling_plan: sellingPlanInput.value };
            }
            const productInput = productForm.querySelector(
              "input[data-productId]"
            );
            let giftProducts = [];
            if (productInput) {
              const productId = productInput.getAttribute("data-productId");
              for (const key in window.freeGiftMapping) {
                if (window.freeGiftMapping[key].includes(String(productId))) {
                  if (
                    !giftProducts.some((giftProduct) => giftProduct.id === key)
                  ) {
                    giftProducts.push({
                      id: key,
                      quantity: 1,
                    });
                  }
                }
              }
            }
            // Add the additional product to the cart
            let groupProductsToAdd = [];
            const cartData = window.cart;
            if (cartData && giftProducts.length > 0) {
              const { items } = cartData;
              for (const giftProduct of giftProducts) {
                const isExist = items.some(
                  (item) => String(item.id) === giftProduct.id
                );
                if (!isExist) {
                  groupProductsToAdd.push(giftProduct);
                }
              }
            }

            groupProductsToAdd.unshift(body);
            const response = await fetch("/cart/add.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                items: groupProductsToAdd,
              }),
            });

            if (response.ok) {
              // btn.isClicked = true;

              setTimeout(() => {
                window.location.href = "/cart";
              }, window.cart_redirect_delay || 0);
            } else {
              // If the network request failed, just reset the button with the original text
              button.innerHTML = originalButtonText;
            }
          }
        }
      })
    })
  }

  if (atcBtns) {
    atcBtns.forEach((button) => {
      handleButtonClick(button);
    });
  }

  if (shopAllAtcBtns) {
    shopAllAtcBtns.forEach((button) => {
      handleButtonClick(button, false);
    });
  }

  if (addToCartButtons) {
    addToCartButtons.forEach((button) => {
      button.addEventListener("click", async function (event) {
        event.stopPropagation();
        event.preventDefault();
        // button.disabled = true;
        // Check if the button is for any of the Mushroom Coffee 30 Serving variants

        // const btn = event.target.closest(
        //   ".tvg_recharge_product_add_to_cart_form_nGmuOW_ProductForm-submitButton"
        // );

        // if (btn.isClicked) return;

        // Save original button text (if network request fails, we'll remove the spinner and put the original text back)
        var originalButtonText = button.textContent;

        // Swap the button text with our loader
        button.innerHTML = `<div class="loading__spinner__add-to-cart"></div>`;

        var productForm = button.closest("form");
        if (productForm) {
          var confirmationFailure = productForm.querySelector(
            "#confirmation-failure"
          );
          var variantInput = productForm.querySelector('input[name="id"]');
          const sellingPlanInput = productForm.querySelector(
            'input[name="selling_plan"]'
          );
          if (variantInput) {
            var variantId = variantInput.value;
            conversationTracking(variantId);
            let body = {
              id: variantId,
              quantity: 1,
            };
            if (sellingPlanInput) {
              body = { ...body, selling_plan: sellingPlanInput.value };
            }

            const productInput = productForm.querySelector(
              "input[data-product-id]"
            );
            let giftProducts = [];
            if (productInput) {
              const productId = productInput.getAttribute("data-product-id");
              for (const key in window.freeGiftMapping) {
                // if(ids.includes(key)) continue
                if (window.freeGiftMapping[key].includes(String(productId))) {
                  if (
                    !giftProducts.some((giftProduct) => giftProduct.id === key)
                  ) {
                    giftProducts.push({
                      id: key,
                      quantity: 1,
                    });
                  }
                }
              }
              // Add the additional product to the cart
              let groupProductsToAdd = [];
              const cartData = window.cart;
              if (cartData && giftProducts.length > 0) {
                const { items } = cartData;
                for (const giftProduct of giftProducts) {
                  const isExist = items.some(
                    (item) => String(item.id) === giftProduct.id
                  );
                  if (!isExist) {
                    groupProductsToAdd.push(giftProduct);
                  }
                }
              }

              groupProductsToAdd.unshift(body);

              // Check if we already have this product in the cart (7434931208297 superfood creamer, 7462384959593 chai)
              // This is a promo product that should only be able to be added once
              const creamerPromoProductId = 7434931208297;
              const chaiPromoProductId = 7462384959593;
              const cocoaPromoProductId = 7468768723049;
              let skipAdd = false;
              if (creamerPromoProductId || chaiPromoProductId) {
                const cartContentsRequest = await fetch(window.Shopify.routes.root + 'cart.js');

                if (cartContentsRequest.ok) {
                  const cartContents = await cartContentsRequest.json();
                  cartContents.items.forEach(item => {
                    if (item.product_id == creamerPromoProductId || item.product_id == chaiPromoProductId || item.product_id == cocoaPromoProductId) {
                      skipAdd = true;
                    }
                  })
                }
              }

              if (skipAdd) {
                // just redirect to the cart
                window.location.href = "/cart";
              } else {
                const response = await fetch("/cart/add.js", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({
                    items: groupProductsToAdd,
                  }),
                });
                if (response.ok) {
                  // btn.isClicked = true;

                  // Apply discount after successful product addition
                  const discount_code = document.cookie.split(';').find(row => row.includes('discount_code'))?.split('=')[1];

                  if (discount_code) {
                    // Apply discount to the cart
                    await fetch(`/discount/${discount_code}`);
                  }

                  window._conv_q = window._conv_q || [];
                  _conv_q.push(["triggerConversion", "100461720"]);
                  setTimeout(() => {
                    window.location.href = "/cart";
                  }, window.cart_redirect_delay || 0);
                } else {
                  // If the network request failed, just reset the button with the original text and throw an error
                  button.innerHTML = originalButtonText;
                  confirmationFailure.classList.remove("hidden");
                  throw new Error("Network response was not ok");
                }
              }
            }
          }
        }
      });
    });
  }

  var cartForm = document.getElementById("cartform");

  if (cartForm) {
    var shopMoneyFormat =
      document.getElementById("shop-money-format").dataset.moneyFormat;
    var quantityInputs = cartForm.querySelectorAll(".cart-quantity-input");

    quantityInputs.forEach((input) => {
      var productId = input
        .closest(".cart-item")
        .getAttribute("data-cart-item-id");

      // 41903044755561 is superfood creamer (50% discount promo)
      // 42034475827305 is chai (50% discount promo)
      if (productId === "41212477669481" || productId === "41934688649321" || productId === "42034475827305" || productId === "42061107265641") {
        input.value = 1;
        input.disabled = true;
        input
          .closest(".tvg_cart_7EowpW_CartItem__qty")
          .classList.add("disable-quantity-buttons");
      } else {
        input.addEventListener("change", function (event) {
          event.preventDefault();
          var quantity = input.value;

          const tr = input.closest("tr")
          const variant_id = tr.getAttribute('data-cart-item-id')

          if (quantity > 0) {
            fetch("/cart/change.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
              body: JSON.stringify({
                id: variant_id,
                quantity: quantity,
              }),
            })
              .then((response) => {
                if (!response.ok) {
                  throw new Error("Network response was not ok");
                }
                return response.json();
              })
              .then((cart) => {
                updateCartDisplay(cart);

                // Convert Experiments conversion tracking
                window._conv_q = window._conv_q || [];
                _conv_q.push(["triggerConversion", "100461720"]);
              })
              .catch((error) => {
                console.error(
                  "There was a problem with the fetch operation:",
                  error
                );
              });
          }
        });
      }
    });
  }

  function updateCartDisplay(cart) {
    cart.items.forEach((item) => {
      var itemElement = document.querySelector(
        `.cart-item[data-line-item-id="${item.key}"]`
      );

      if (itemElement) {
        var originalLinePrice =
          item.selling_plan_allocation.compare_at_price * item.quantity;
        itemElement.querySelector(".item-total-price").innerText =
          Shopify.formatMoney(item.final_line_price, shopMoneyFormat);
        itemElement.querySelector(".item-original-price").innerText =
          Shopify.formatMoney(originalLinePrice, shopMoneyFormat);
      }
    });

    var totalElement = document.querySelector(
      ".tvg_cart_7EowpW_Cart-totalPrice"
    );
    if (totalElement) {
      totalElement.innerText = Shopify.formatMoney(
        cart.total_price,
        shopMoneyFormat
      );
    }
  }

  function handleButtonClick(button, showSpinner = true) {
    button.addEventListener("click", async function (event) {
      event.stopPropagation();
      event.preventDefault();

      // Save original button text (if network request fails, we'll remove the spinner and put the original text back)
      var originalButtonText = button.textContent;

      // Swap the button text with our loader
      if (showSpinner) {
        button.innerHTML = `<div class="loading__spinner__add-to-cart"></div>`;
      }

      const productForm = button.closest("form");
      if (productForm && window.freeGiftMapping) {
        const variantInput = productForm.querySelector('input[name="id"]');
        const sellingPlanInput = productForm.querySelector(
          'input[name="selling_plan"]'
        );
        if (variantInput) {
          const variantId = variantInput.value;
          let body = {
            id: variantId,
            quantity: 1,
          };
          if (sellingPlanInput) {
            body = { ...body, selling_plan: sellingPlanInput.value };
          }
          const productInput = productForm.querySelector(
            "input[data-product-id]"
          );
          let giftProducts = [];
          if (productInput) {
            const productId = productInput.getAttribute("data-product-id");
            for (const key in window.freeGiftMapping) {
              if (window.freeGiftMapping[key].includes(String(productId))) {
                if (
                  !giftProducts.some((giftProduct) => giftProduct.id === key)
                ) {
                  giftProducts.push({
                    id: key,
                    quantity: 1,
                  });
                }
              }
            }
          }
          // Add the additional product to the cart
          let groupProductsToAdd = [];
          const cartData = window.cart;
          if (cartData && giftProducts.length > 0) {
            const { items } = cartData;
            for (const giftProduct of giftProducts) {
              const isExist = items.some(
                (item) => String(item.id) === giftProduct.id
              );
              if (!isExist) {
                groupProductsToAdd.push(giftProduct);
              }
            }
          }

          groupProductsToAdd.unshift(body);
          const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              items: groupProductsToAdd,
            }),
          });

          if (response.ok) {
            // btn.isClicked = true;

            setTimeout(() => {
              window.location.href = "/cart";
            }, window.cart_redirect_delay || 0);
          } else {
            // If the network request failed, just reset the button with the original text
            if (showSpinner) {
              button.innerHTML = originalButtonText;
            }
          }
        }
      }
    });
  }
});
